module.exports = __webpack_public_path__ + "static/media/PM143.41169925.png";